import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Layout from './components/Layout/Layout'
import Home from './components/Home/Home'
import BlogsPage from './components/BlogsPage/BlogsPage'
import BlogPost from './components/BlogPost/BlogPost'
import About from './components/About/About'
import Gallery from './components/Gallery/Gallery'
import Portfolio from './components/Portfolio/Portfolio'
import Experience from './components/Experience/Experience'
import Education from './components/Education/Education'
import Certifications from './components/Certifications/Certifications'
import Workshops from './components/Workshops/Workshops'
import Skills from './components/Skills/Skills'
import Volunteering from './components/Volunteering/Volunteering'
import './index.css'

const App = () => {
  return (
    <Router>
      <div className="light">
        <Layout>
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/about' element={<About />} />
            <Route path='/portfolio' element={<Portfolio />} />
            <Route path='/gallery' element={<Gallery />} />
            <Route path='/blogs' element={<BlogsPage />} />
            <Route path='/blogs/:slug' element={<BlogPost />} />
            <Route path='/experience' element={<Experience />} />
            <Route path='/education' element={<Education />} />
            <Route path='/certifications' element={<Certifications />} />
            <Route path='/workshops' element={<Workshops />} />
            <Route path='/skills' element={<Skills />} />
            <Route path='/volunteering' element={<Volunteering />} />
          </Routes>
        </Layout>
      </div>
    </Router>
  )
}

export default App


